import { useSyncExternalStore } from 'react'
import { CollectionState } from '../..'

export function useClickCell (state: CollectionState) {
  return useSyncExternalStore(
    callback => state.addEventListener('clickedCellChanged', callback),
    () => state.clickedCell
  )
}
